import { Component, OnInit,ViewChild } from '@angular/core';
import { RequestService } from '../../../../services/request.service';
import { environment } from '../../../../environments/environment';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { HttpClient, HttpHeaders ,HttpParams} from '@angular/common/http'; 
import { Router, ActivatedRoute } from "@angular/router";
import { DataTableDirective} from 'angular-datatables';
import { from, Subject } from 'rxjs';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {

  @ViewChild(DataTableDirective, {static: false})
	dtElement: DataTableDirective;
	dtOptions: any = {};
	// dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  isEditMode: boolean=false;
  userForm: any = {}
  constructor(
    private request : RequestService,
    private http: HttpClient,
    private router: Router,
    private datePipe : DatePipe
  ) {this.isEditMode = false;}

  isLoading=false;
  roleId=0;
  ngOnInit() {
    this.roleId = Number(localStorage.getItem("roleId"));
    this.ViewUsers();

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      dom: 'Bfrtip',
        buttons: [
        {
          extend: 'csv',
          text:      '<i class="fa fa-file-text-o"></i>',
          titleAttr: 'Download as CSV',
          title: 'User Master' 
        },
        {
          extend: 'excel',
          text:      '<i class="fa fa-file-excel-o"></i>',
          titleAttr: 'Download as Excel',
          title: 'User Master' 
        },
        {
          extend: 'pdf',
          text: '<i class="fa fa-file-pdf-o"></i>',
          titleAttr: 'Download as Pdf',
          title: 'User Master' 
        }
      ]
    };
  }

  ClearForm(){
    this.isEditMode=false;
    this.userForm={};
  }

  rowData;
  userDetails=[];
  async ViewUsers(){
    try {
      const user = {
        'userId': 0,
      };
      this.isLoading=true;
      this.dtTrigger=new Subject<any>();
      const data: any = await this.request.post('/auth/view_user',user);
      this.userDetails=[];
      //alert(data);
      this.dtTrigger.next();
      for (let objKey of Object.keys(data)) {
        let dataObj = data[objKey];
        if(objKey=="result"){
          for (let objKey1 of Object.keys(dataObj)) {
            if(dataObj[objKey1].roleId>1){
              this.userDetails.push(dataObj[objKey1]);
            }
          } 
        }				
      }
      this.rowData = this.userDetails;
      this.isLoading=false;
    } catch (error) {}
  }

  oiletViewDetails;
  async EditUser(user){
    try {
      this.isEditMode=true;
      this.userForm = user;
      $("#userId").val(this.userForm.userId);
    } catch (error) {}
  }

  async DeleteUser(userId) {
    const confirm = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
      });
      if (confirm.value) {
      const user = {
        'userId': userId
      };
      const allow: any = await this.request.post('/auth/delete_user/',user);
      if (allow) {
        // Successfully Deleted
        Swal.fire(
        'Deleted!',
        'User Information has been deleted.',
        'success'
        );
        // Reload DataTable
        // this.ViewDrivers();
        window.location.reload();
        // this.ngOnInit();
      } else {
        Swal.fire(
          'Error!'
        );
      }
    }
  }

  onSubmit(): void {
    if (this.isEditMode) {
      this.UpdateUser();
    } else {
      this.SaveUser();
    }
  }

  isViewMode=false;
  isUpdatedRecord;
  message;
  async SaveUser(){
    try {
      this.isLoading=true;
      const userData = {
        'firstName': this.userForm.firstName,
        'lastName':this.userForm.lastName,
        'email':this.userForm.email,
        'mobileNo':Number(this.userForm.mobileNo),
        'address':this.userForm.address,
        'aadharNo':"NA",
        'roleId':2
      };
      // console.log(userData);
      const save: any = await this.request.post('/auth/register_user',userData);
      // console.log(save);
      for (let objKey of Object.keys(save)) {
        let dataObj = save[objKey];
        if(objKey=="status"){
        this.isUpdatedRecord = save[objKey];
        }
        if(objKey=="message"){
        this.message = save[objKey];
        }
      }
      if (this.isUpdatedRecord=="SUCCESS") {
        const result = await Swal.fire({
        title: 'Successfully Save',
        text: 'Saved Changes.',
        type: 'success',
        showConfirmButton: false,  
        timer: 1500
        // confirmButtonText: 'Ok'
        });
        if (result.value) {
        // Form Reset
        window.location.reload();
        }
        window.location.reload();
      } else{
        const result = await Swal.fire({
          title: "Oops ?",
          text: this.message,   
          type: "warning",   
          showCancelButton: false,      
          confirmButtonColor: "#FF0000",   
          confirmButtonText: "Close",   
          closeOnConfirm: false,   
          closeOnCancel: false,
          customClass: "Custom_Cancel"
        });
      }
      this.isEditMode=false;
      this.isViewMode=false;
      this.isLoading=false;
    } catch (error) { }
  }

  async UpdateUser(){
      try {
        this.isLoading=true;
      const userData = {
        'userId': Number($("#userId").val()),
        'firstName': this.userForm.firstName,
        'lastName':this.userForm.lastName,
        'email':this.userForm.email,
        'mobileNo':Number(this.userForm.mobileNo),
        'address':this.userForm.address,
        'aadharNo':"NA",
        'roleId':2
      };
      // console.log(userData);
      const save: any = await this.request.post('/auth/update_user',userData);
      for (let objKey of Object.keys(save)) {
        let dataObj = save[objKey];
        if(objKey=="status"){
        this.isUpdatedRecord = save[objKey];
        }
        if(objKey=="message"){
        this.message = save[objKey];
        }
      }
      if (this.isUpdatedRecord=="SUCCESS") {
        // alert("Save Successfully");
        const result = await Swal.fire({
        title: 'Successfully Updated',
        text: 'Saved Changes.',
        type: 'success',
        showConfirmButton: false,  
        timer: 1500
        // confirmButtonText: 'Ok'
        });
        if (result.value) {
        // Form Reset
        window.location.reload();
        }
        window.location.reload();
      } else{
        const result = await Swal.fire({
          title: "Oops ?",
          text: this.message,   
          type: "warning",   
          showCancelButton: false,      
          confirmButtonColor: "#FF0000",   
          confirmButtonText: "Close",   
          closeOnConfirm: false,   
          closeOnCancel: false,
          customClass: "Custom_Cancel"
        });
      }
      this.isEditMode=false;
      this.isViewMode=false;
      this.isLoading=false;
    } catch (error) { }
  }

}
